import styled from 'styled-components'
import { BannerButton } from '../../../shared/Buttons/Buttons.styles'

export const Title = styled.h3`
  text-transform: capitalize;
  text-align: center;
  margin: 4rem auto 2rem;
  padding-bottom: 1.5rem;

  &:after {
    content: '';
    display: block;
    height: 2px;
    background-color: ${props => props.theme.colors.cobalt};
    max-width: ${props => props.theme.sizes.maxWidthTitleSmall};
    margin: 1rem auto 0;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-top: 8rem;

    &:after {
      max-width: ${props => props.theme.sizes.maxWidthTitle};
    }
  }
`

export const SliderContainer = styled.div`
  position: relative;
  margin-bottom: 3.6rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 6.4rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-bottom: 9.6rem;

    .slick-list {
      margin: 0 -1.6rem;
    }
  }

  .slick-prev,
  .slick-next {
    display: none !important;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      display: block !important;
      left: auto;
      bottom: -6.3rem;
      top: auto;

      &:before {
        color: ${props => props.theme.colors.black};
        background-image: url(../arrow-right.svg);
        content: '';
        width: 2.5rem;
        height: 2.3rem;
        display: block;
        background-size: 100%;
        transform: rotate(180deg);
      }
    }
  }

  .slick-next {
    left: 3rem;
    bottom: -6.1rem;

    &:before {
      transform: rotate(0deg);
    }
  }

  .slick-dots {
    position: relative;
    margin-top: -0.3rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      float: right;
      margin-top: 0.8rem;
      width: 50%;
      text-align: right;
    }

    li {
      cursor: pointer;
      display: inline-block;
      width: 4.9rem;
      height: 0.2rem;
      margin-right: 0.2rem;

      &:last-child {
        margin-right: 0;
      }

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        width: 5.4rem;
        margin-right: 0.8rem;
      }

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        width: 5.4rem;
        margin-right: 1.1rem;
      }

      button {
        width: 5.2rem;
        /* To increase clickable area of the position indicators */
        padding: 3rem 0;
        margin: -3rem 0;

        &:before {
          content: '';
          opacity: 1;
          width: 100%;
          border: 1px solid ${props => props.theme.colors.lightGrey};
          height: 1px;
        }

        @media screen and (min-width: ${props => props.theme.responsive.small}) {
          width: 5.4rem;
        }
      }
      &.slick-active {
        button {

          &:before{
            border: 1px solid ${props => props.theme.colors.cobalt};
          }
        }
      }
    }

    button {
      width: 100%;
      height: auto;
      padding: 0;
    }
  }
`

export const BlackButton = styled(BannerButton)`
  margin-bottom: 2.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 10rem;
  }

  a {
    border: 1px solid ${props => props.theme.colors.black};
    color: ${props => props.theme.colors.black};
  }
`
